<div id="explorerBottomOffcanvas" 
     class="offcanvas offcanvas-bottom" 
     [ngClass]="{'show': tabService.navInfo.explorer.bottomViewVisible, 'wide': !tabService.navInfo.explorer.sideViewVisible}" 
     data-bs-scroll="true" 
     data-bs-backdrop="false" 
     tabindex="-1" 
     aria-labelledby="offcanvasScrollingLabel">
    
    <div id="explorerBottomOffcanvasBody" class="offcanvas-body">
        <mat-tab-group preserveContent [(selectedIndex)]="tabService.navInfo.explorer.activeBottomNav">
            <mat-tab label="RESULTS">
                <p>{{ searchService.searchResultCount }}@if (searchService.searchResultMoreAvailable) {<span>+</span>} results@if (searchService.searchResultCount > searchService.maxRecords || searchService.searchResultMoreAvailable) {<span> (Showing first {{ searchService.searchResultCount }})</span>}</p>
                @for (rec of searchService.searchResult(); track rec.id) {
                    <div class="searchResultItem"
                        (mouseenter)="mapService.highlightResultLayerFeature(rec.feature, true)" 
                        (mouseleave)="mapService.highlightResultLayerFeature(rec.feature, false)"
                        (click)="showRecordDetails(rec)">
                        <h5 class="searchResultItemTitle">{{ rec.title }}</h5>
                        <p class="searchResultItemInfo">
                            @if (rec.published) {
                                <span>Published: {{ rec.published }}</span>
                            } 
                            @if (rec.resourceUrl) {
                                <i class="material-icons copyResourceUrlIcon"
                                    title="Copy URL to clipboard" aria-label="Copy URL to clipboard"
                                    (click)="$event.stopPropagation();copyResourceUrlToClipboard(rec)">content_copy</i>
                            }
                            @if (rec.wmsUrl && !rec.wmsMapLayer) {
                                <i class="material-icons copyResourceUrlIcon" 
                                    title="Show WMS layer" aria-label="Show WMS layer"
                                    (click)="$event.stopPropagation();addResourceWMSLayer(rec)">layers</i>
                            }
                            @if (rec.wmsMapLayer) {
                                <i class="material-icons copyResourceUrlIcon" 
                                    title="Hide WMS layer" aria-label="Hide WMS layer"
                                    (click)="$event.stopPropagation();removeResourceWMSLayer(rec)">layers_clear</i>
                            }
                        </p>
                    </div>
                }
            </mat-tab>
            <mat-tab label="JOBS">
                @for (job of userService.jobs(); track job.jobID) {
                    <div class="jobListItem" (click)="showJobDetails(job)">
                        <div class="jobListItemIconDiv">
                            @if (job.status === 'successful') {
                                <i class="material-icons jobListItemStatusIcon success">done</i>
                            }
                            @if (job.status === 'failed') {
                                <i class="material-icons jobListItemStatusIcon error">error</i>
                            }
                            @if (job.status === 'running') {
                                <i class="material-icons jobListItemStatusIcon running">hourglass_empty</i>
                            }
                        </div>
                        <div class="jobListItemTextDiv">
                            <h5 class="jobHeader">{{ job.processID }} ({{ job.jobID }})</h5>
                            <p class="jobMessage">{{ job.updated }} {{ job.message }}</p>
                        </div>
                        @if (jobHasWMSLayer(job)) {
<!--                            <input class="alphaInput" type="range" 
                                min="0" max="1" step="0.1" [value]="job.wmsopacity"
                                (input)="setJobWMSLayersOpacity(job, $event)" 
                                (click)="$event.stopPropagation()">
                        -->
                            <i class="material-icons copyResourceUrlIcon"
                                title="Hide WMS layer" aria-label="Hide WMS layer"
                                (click)="$event.stopPropagation();removeJobWMSLayers(job)">layers_clear</i>
                        }
                        <i class="material-icons deleteJobIcon" 
                            title="Delete job" aria-label="Delete job"
                            (click)="$event.stopPropagation();userService.deleteJob(job.jobID)">stop</i>
                    </div>
                }
                <button class="bigButton jobListRefreshButton" (click)="userService.getJobs()">
                    <i class="material-icons" title="Refresh" aria-label="Refresh">refresh</i></button>
            </mat-tab>
            <mat-tab label="MESSAGES"> 
                @for (msg of messageService.messages(); track $index) {
                    <div>
                        <p class="messageTimestamp">{{ msg.timestamp.toLocaleString() }}</p>
                        <p class="messageContent">{{ msg.message }}</p>
                    </div>
                }
            </mat-tab>
            <mat-tab label="MAP"> 
                @for (rec of [...mapService.wmsRecordByLayer.values()].reverse(); track $index) {
                    <div>
                        <p class="mapname">{{ getFilenameFromLayerName(rec.wmsLayerName) }}</p>
                            <input class="alphaInput" type="range" 
                                min="0" max="1" step="0.1" [value]="rec.wmsopacity"
                                (input)="setWMSLayerOpacity(rec, $event)" 
                                (click)="$event.stopPropagation()">
                            <i class="material-icons copyResourceUrlIcon"
                                title="Adjust style" aria-label="Adjust style"
                                (click)="$event.stopPropagation();showSldEditor(rec)">image</i>
                            <i class="material-icons copyResourceUrlIcon" 
                                title="Hide WMS layer" aria-label="Hide WMS layer"
                                (click)="$event.stopPropagation();removeResourceWMSLayer(rec)">layers_clear</i>
                            <i class="material-icons copyResourceUrlIcon" 
                                title="Zoom to layer" aria-label="Zoom to layer"
                                (click)="$event.stopPropagation();zoomToWMSLayer(rec)">fit_screen</i>
                    </div>
                }
            </mat-tab>
        </mat-tab-group>
    </div>
    @if (mapService.featureInfoChartData) {
        <div id="featureInfoView">
            <div class="featureInfoChart">
                <app-featureinfochart></app-featureinfochart>
                <button id="featureInfoViewCloseButton" type="button" (click)="hideFeatureInfoView()" class="btn-close" 
                    aria-label="Close" title="Close"></button>
            </div>
        <!--
            <app-featureinfoview></app-featureinfoview>
            <button id="featureInfoViewCloseButton" type="button" (click)="hideFeatureInfoView()" class="btn-close" 
                aria-label="Close" title="Close"></button>
        -->
        </div>
    }
</div>
<div id="searchItemDetailsPanel" 
    class="offcanvas offcanvas-record-details" 
    [ngClass]="{'show': recordDetails}" 
    data-bs-scroll="true" 
    data-bs-backdrop="false" 
    tabindex="-1" 
    aria-labelledby="offcanvasScrollingLabel">

    <div id="searchItemDetailsPanelHeader">
        <div id="searchItemDetailsTitle">{{ recordTitle }}</div>
        <button id="searchItemDetailsPanelCloseButton" type="button" (click)="hideRecordDetails()" class="btn-close" 
            aria-label="Close" title="Close"></button>
    </div>
    @if (recordQuicklook) {
        <div><img class="quicklookImg" [src]="recordQuicklook"></div>
    }
    <pre id="searchItemDetailsBody">{{ recordDetails }}</pre>
</div>
<div id="jobDetailsPanel" 
    class="offcanvas offcanvas-record-details" 
    [ngClass]="{'show': visibleJob && !sldEditorVisible}" 
    data-bs-scroll="true" 
    data-bs-backdrop="false" 
    tabindex="-1" 
    aria-labelledby="offcanvasScrollingLabel">

    <div id="jobDetailsPanelHeader">
        <div id="jobDetailsTitle">Result from job {{ visibleJob?.jobID }}</div>
        <button id="jobDetailsPanelCloseButton" type="button" (click)="hideJobDetails()" class="btn-close" 
            aria-label="Close" title="Close"></button>
    </div>
<!--
    <div class="fileinfo" *ngFor="let f of visibleJobResults">
        <p class="filekey">{{ f.key }}</p>
        <p class="filedetails">
            <button class="fileDownloadButton" (click)="workspaceService.downloadFile(f)">
                <i class="material-icons" title="Download" aria-label="Download">cloud_download</i></button>
            <button class="fileDownloadButton" *ngIf="f.resourceUrl"
                (click)="$event.stopPropagation();copyResultUrlToClipboard(f)">
                <i class="material-icons" title="Copy URL to clipboard" aria-label="Copy URL to clipboard">content_copy</i></button>
            Modified: {{ f.lastmodified }} Size: {{ f.size }}
        </p>
    </div>
-->
    <div class="stacitems">
    @for (f of visibleJob?.stacItems; track $index) {
        <div class="iteminfo">
            <p class="itemtitle">
                @if (f.href) {
                    <button class="fileDownloadButton"
                        (click)="$event.stopPropagation();copyStacItemHrefToClipboard(f)">
                        <i class="material-icons" title="Copy URL to clipboard" aria-label="Copy URL to clipboard">content_copy</i></button>
                }
                {{ f.id }}
                @if (f.wmsUrl && !f.wmsMapLayer) {
                    <i class="material-icons copyResourceUrlIcon"
                        title="Show WMS layer" aria-label="Show WMS layer"
                        (click)="$event.stopPropagation();addResourceWMSLayer(f)">layers</i>
                }
                @if (f.wmsMapLayer) {
                    <i class="material-icons copyResourceUrlIcon"
                        title="Hide WMS layer" aria-label="Hide WMS layer"
                        (click)="$event.stopPropagation();removeResourceWMSLayer(f)">layers_clear</i>
                }
            </p>
            @if (f.assets) {
                @for (a of f.assets; track a.key;) {
                    <div class="assetinfo">{{ a.key }}: {{ a.title }}
                        <p class="assetdetails">
                            @if (a.href) {
                                <button class="fileDownloadButton" (click)="workspaceService.downloadFromUserS3(a.href)"> 
                                    <i class="material-icons" title="Download" aria-label="Download">cloud_download</i></button>
                            }
                            @if (a.wmsUrl && !a.wmsMapLayer) {
                                <i class="material-icons copyResourceUrlIcon"
                                    title="Show WMS layer" aria-label="Show WMS layer"
                                    (click)="$event.stopPropagation();addResourceWMSLayer(a)">layers</i>
                            }
                            @if (a.wmsMapLayer) {
                                <i class="material-icons copyResourceUrlIcon"
                                    title="Hide WMS layer" aria-label="Hide WMS layer"
                                    (click)="$event.stopPropagation();removeResourceWMSLayer(a)">layers_clear</i>
                            }
                            @if (a.wmsMapLayer) {
                                <i class="material-icons copyResourceUrlIcon"
                                    title="Adjust style" aria-label="Adjust style"
                                    (click)="$event.stopPropagation();showSldEditor(a)">image</i>
                            }
                            Modified: {{ a.lastmodified }} Size: {{ a.size }}
                        </p>
                    </div>
                }
            }
            
        </div>
    }
    </div>
</div>
<!--(cdkDragMoved)="onDragMoved($event)"-->
<div cdkDrag id="sldEditorPanel" cdkDragBoundary="body"
    class="offcanvas offcanvas-record-details" 
    [ngClass]="{'show': sldEditorVisible}" 
    data-bs-scroll="true" 
    data-bs-backdrop="false" 
    tabindex="-1" 
    aria-labelledby="offcanvasScrollingLabel">

    @if (sldEditorVisible) {
        <div id="sldEditorPanelHeader">
            <app-sldeditor [sldEditorItem]="sldEditorItem" (sldUpdated)="onSldUpdated($event)"></app-sldeditor>
            <button id="sldEditorPanelCloseButton" type="button" (click)="hideSldEditor()" class="btn-close" 
                aria-label="Close" title="Close"></button>
        </div>
    }
</div>

<div id="downloadForm" hidden>
    <form ngNoForm id="downloadFormForm" action="{{ workspaceService.downloadUrl }}" method="post">
        <input type="text" name="csrfmiddlewaretoken" required id="id_csrfmiddlewaretoken">
        <input type="text" name="key" required id="id_key">
        <input type="text" name="endpoint" required id="id_endpoint">
        <input type="text" name="access" required id="id_access">
        <input type="text" name="secret" required id="id_secret">
        <input type="text" name="bucket" required id="id_bucket">
        <input type="submit" value="Submit" id="id_submit">
    </form>
</div>
